const clientInformation = () => {

    clientInformation.languaje = "";
    clientInformation.Password = "";
    clientInformation.Error = false;
    clientInformation.Udf1 = "";
    clientInformation.IPAddress = "";
    clientInformation.InstanceID = 1;
    clientInformation.SkinID = 1;
    clientInformation.InstanceID = 1;
    clientInformation.OnFile = false;
    clientInformation.CustomerID = 1;
    clientInformation.Email = "";

    clientInformation.Name = localStorage.getItem('Name');
    clientInformation.LastName = localStorage.getItem('LastName');

    clientInformation.CurrencyCode = localStorage.getItem('CurrencyCode');
    clientInformation.AvailableBalance = localStorage.getItem('AvailableBalance');
    clientInformation.WithdrawalBalance = localStorage.getItem('WithdrawalBalance');
    clientInformation.IPAddress = localStorage.getItem('IPAddress');

    clientInformation.CustomerPIN = localStorage.getItem('User');
    clientInformation.Udf1 = localStorage.getItem('Udf1');
    clientInformation.InstanceID = localStorage.getItem('InstanceID');
    clientInformation.SkinID = localStorage.getItem('SkinID');
    clientInformation.OnFile = localStorage.getItem('OnFile');
    clientInformation.CustomerID = localStorage.getItem('CustomerID');
    clientInformation.Email = localStorage.getItem('Email');

    return clientInformation;
}

clientInformation.funcMapCustomer = async (data) => {
    localStorage.setItem('Name', await data.Authentication.Name);
    localStorage.setItem('LastName', await data.Authentication.LastName);
    localStorage.setItem('OnFile', await data.Authentication.OnFile);
    localStorage.setItem('CustomerID', await data.Authentication.CustomerID);
    localStorage.setItem('Email', await data.Authentication.Email);
    localStorage.setItem('CustomerID', await data.Authentication.CustomerID);
}

clientInformation.funcMapBalance = async (data) => {
    localStorage.setItem('AvailableBalance', await data.Authentication.AvailableBalance);
    localStorage.setItem('WithdrawalBalance', await data.Authentication.WithdrawalBalance);
    localStorage.setItem('CurrencyCode', await data.Authentication.CurrencyCode);
}

export default clientInformation;

